import React, { useCallback, useEffect, useReducer, useState } from "react"
import { obterMarketingAutomatico } from "../../../services/marketingAutomatico"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { MarketingAutomaticoInicial } from "../models/marketingAutomaticoModel"
import { MarketingAutomaticoActionsTypes } from "./marketingAutomaticoActions"
import { MarketingAutomaticoContext } from "./MarketingAutomaticoContext"
import { marketingAutomaticoReducer } from "./marketingAutomaticoReducer"

export function MarketingAutomaticoContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(marketingAutomaticoReducer, MarketingAutomaticoInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterMarketingAutomatico(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar estratégias")
            } else {
                setErroCarregamento(null)
                dispatch({ type: MarketingAutomaticoActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar estratégias")
        } finally {
            setLoading(false)
        }
    }, [setLoading])

    useEffect(() => {
        carregar()
    }, [carregar])

    return (
        <MarketingAutomaticoContext.Provider
            value={{ dados, dispatch, erroCarregamento, recarregar: carregar }}
        >
            <Loading />
            {children}
        </MarketingAutomaticoContext.Provider>
    )
}
